var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_196)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.7396,
    y: 9.26318,
    width: 59.64,
    height: 59.64,
    rx: 29.82,
    fill: "#6C00F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0545 33.8334L34.6657 31.8596L24.4994 37.7809V49.5826L34.6657 55.4835L44.8321 49.5826V31.2289L50.4733 27.9529L56.1145 31.2289V37.7809L50.4733 41.0569L47.0845 39.0831V44.3329L50.4733 46.3066L60.6397 40.4057V28.604L50.4733 22.7031L40.307 28.604V46.9577L34.6657 50.2337L29.0245 46.9577V40.3854L34.6657 37.1094L38.0545 39.0831V33.8334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_196",
    x: 0.139624,
    y: 0.0231833,
    width: 84.84,
    height: 84.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_196"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_196",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_196"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.4994,
    y: 22.7031,
    width: 36.12,
    height: 32.76,
    rx: 16.38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.185934336fb6e9a232049f186b56cd8c.svg";
export { ForwardRef as ReactComponent };